import { ReactNode } from 'react';
import { rpmTheme } from './theme';
import { GetBrandTheme } from '@leadflow/shared/theme/GetBrandTheme';

const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  return <GetBrandTheme brandTheme={rpmTheme}>{children}</GetBrandTheme>;
};

export default ThemeProviderWrapper;
